import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { getLensBrandsURL, getSTLensTypesURL,getSTLensIndexURL, getSTLensSphURL,getSTLensCylURL, getSTProductsURL, getProductByCodeURL, getMatrixQuantityURL, getSTOrderPreviewURL, getSubmitSTOrderURL, getOrderURL, getChangeOrderStateRL, getOrderPaymentURL, getOrderPaymentConfirmationURL, getTestRedirectURL, getCusomerExcludedFromRequiredToolsURL} from '../api';
import moment from 'jalali-moment'
import { GroupBy } from "../helpers/mmg";
import { InputOutlined } from "@mui/icons-material";
import { setOrderLoadingFalse } from "./orders.slice";

export const zeroPad = (num, places) => String(num).padStart(places, '0');


// initial state
export const initialState = {
  loading: false,
  boxMessage : '',
  boxType : 0,//1 Error , 2 Success, 3 Info
  error: false,
  errorMessage : '',
  successMessage : '',
  currentPageIndex : 0,
  hasMore : true,

  customerPortalUserId : '' ,
  customerPortalCreatorId : '',

  lensbrands: [],
  selectedLensBrandId : 0,
  lensTypes : [],
  selectedLensTypeId : 0,
  lensIndexes : [],
  selectedLensIndexId : 0,
  lensSphs : [],
  selectedLensSphId : 0,
  lensCyls : [],
  selectedLensCylId : 0,
  products : [],
  description : '',
  dateMustDelivered : '',
  netPrice : 0,
  selectedProductId : 0,
  selectedProductCode : '',
  selectedProductTitle : '',
  selectedQuantity : '',
  selectedFee : 0,

  items : [],
  previewItems : [],
  previewItemsBackup : [],
  previewItemsDialog : false,
  readOnly : false,

  isLeftOn : false,
  isRightOn : false,
  isOUOn : false,
  selectedRowId : 0,

  selectedSTOrder : {},
  selectedSTOrderId : null,

  searchKey : '',
  orderState : '',

  payTypeId : 1,
  cusomerExcludedFromRequiredTools : false
};
export const NeedCutOptions = [
            { value: '-', label: '-' },
            { value: 'Full', label: 'Full' },
            { value: 'Semi-Rimless', label: 'Semi-Rimless' },
            { value: 'Rimless', label: 'Rimless' },
        ];
// our slice
const stOrderSlice = createSlice({
  name: "storder",
  initialState,
  reducers: {
    setPostRefId: (state, { payload }) =>{
      state.loading = false;
      state.postRefId = payload;
    },
    setSTOrderLoading: (state) => {
      state.loading = true;
    },
    setSTOrderLoadingFalse: (state) => {
      state.loading = false;
    },
    setSTOrderReadonly: (state) => {
      state.readOnly = true;
    },
    setSTOrderWrite: (state) => {
      state.readOnly = false;
    },
    setSTOrderSearchKey : (state, { payload }) =>{
      state.searchKey = payload;
    },
    setCustomerPortalUserId: (state, { payload }) =>{
      state.customerPortalUserId = payload;
    },
    clearCustomerPortalUserId: (state, { payload }) =>{
      state.customerPortalUserId = '';
    },
    setSelectedSTOrderId: (state, { payload }) => {
      state.loading = false;
      console.log("selectedSTOrderId");
      state.fetchPermission = false;// یعنی وارد یک فاکتور شدیم و دیگه مجدد لود نکنه اطلاعات رو
      state.selectedSTOrderId = payload;
    },
    setSelectedSTOrder: (state, { payload }) => {
      state.loading = false;
      state.selectedSTOrder = payload;
      state.selectedSTOrderId = payload.ID;
      state.fetchPermission = false;
    },
    setSTOrderResultBox: (state, { payload }) => {

      console.log("setSTOrderResultBox");
      console.log(payload);
      state.boxMessage = payload.message;
      state.boxType = payload.type;//1 Error , 2 Success, 3 Info
    },
    resetSTOrderResultBox: (state, { payload }) => {
      state.boxMessage = ''
      state.boxType = 0;//1 Error , 2 Success, 3 Info
    },
    setSTOrderCusomerExcludedFromRequiredTools: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.cusomerExcludedFromRequiredTools = payload;
      state.loading = false;
    },
    setSTOrderLensBrands: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.lensbrands = payload;
      state.loading = false;
    },
    loadSTOrder : (state, {payload}) => {
      console.log(payload);
      state.description =  payload.Description;
      state.dateMustDelivered =  payload.selectedDateMustDelivered;
      state.number = payload.Number;
      state.trackingCode = payload.trackingCode;
      var rowId = 1;
      var corrItemRowNumbers = [];
      //console.log(payload.OrderItems);
      var rowsThatHaveCorrespondingLeftRows = payload.OrderItems.filter(element => element.CorrespondingLeftRowNmber !== null);
      console.log("rowsThatHaveCorrespondingLeftRows");
      console.log(rowsThatHaveCorrespondingLeftRows);
      payload.OrderItems.map((leftItem) => {
        rowsThatHaveCorrespondingLeftRows?.map((rightItem) => {
          if(rightItem.CorrespondingLeftRowNmber === leftItem.RowNumber){

            var newItem = { RowId : rowId , RightProductTitle : rightItem.ProductTitle, RightProductCode : rightItem.ProductCode, RightProductId : rightItem.ProductId , LeftProductTitle : leftItem.ProductTitle, LeftProductCode : leftItem.ProductCode, LeftProductId : leftItem.ProductId , Quantity : 2 , Fee : leftItem.Fee , Consumer : rightItem.Consumer, Optician : rightItem.Optician, Axis : rightItem.Axis , NeedTools : rightItem.NeedTools, NeedCut : rightItem.NeedCut};
            newItem.Price =  parseFloat(newItem.Fee) * parseFloat(newItem.Quantity);
            console.log("newItem");
            console.log(newItem);
            state.items.push(newItem);
            rowId++;
            corrItemRowNumbers.push(leftItem.RowNumber);

          }
        });
      });
      
      var otherRows = payload.OrderItems.filter(element => element.CorrespondingLeftRowNmber === null );
      console.log(otherRows);
      otherRows?.map((item) => {
        if(!corrItemRowNumbers.includes(item.RowNumber)){
          console.log("newItem");
          console.log(newItem);
          var newItem = { RowId : rowId , RightProductTitle : item.ProductTitle, RightProductCode : item.ProductCode, RightProductId : item.ProductId , LeftProductTitle : '-', LeftProductCode : '-', LeftProductId : null, Quantity : item.Quantity , Fee : item.Fee , Consumer : '', Optician : '', Axis : '', NeedTools : item.NeedTools, NeedCut : '-' };
          newItem.Price =  parseFloat(newItem.Fee) * parseFloat(newItem.Quantity);
          state.items.push(newItem);
          rowId++;
        }

      });
      //state.items = []ظ
      state.customerPortalUserId = payload.CustomerPortalUserId;
      state.customerPortalCreatorId = payload.CustomerPortalCreatorId;

      state.selectedSTOrderId = payload.OrderId;
      state.OrderHistory = payload.OrderHistory;
      state.orderState = payload.State;
      state.payTypeId = payload.PayTypeID;
      state.netPrice = payload.NetPrice;
      state.cusomerExcludedFromRequiredTools = payload.cusomerExcludedFromRequiredTools;
    },
    setSTOrderSelectedLensBrand: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.selectedLensBrandId = payload;
      state.selectedLensTypeId = 0;
      state.selectedLensIndexId = 0;
      state.selectedLensSphId = 0;
      state.selectedLensCylId = 0;
      state.selectedProductId = 0;
      state.lensTypes = [];
      state.lensIndexes = [];
      state.lensLensSphs = [];
      state.lensLensCyls = [];
      state.products = [];
      state.loading = false;

     
    },
    setSTOrderMatrix: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      //var matrixItems = [];
      //var matrixSingleItem = {};
      //GroupBy(stOrder.matrix , pet => pet.SPH).forEach (function(value, key) {
          //{console.log(key);}
          //<tr>
          //<td>{key}</td>
      //    value.forEach (function(v, k) {
            //{console.log(v);}
            //indents.push(<span key={matrixItemBySPH[k].ProductId}>{matrixItemBySPH[k].CYL}</span>);
            //<td>{v.CYL}</td>
      //    })
         //</tr>
      //})

      state.matrix = payload;
      state.loading = false;
      
    },
    setSTOrderLensTypes: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.lensTypes = payload;
      state.selectedLensTypeId = 0;
      state.loading = false;
    },
    setSTOrderSelectedLensType: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.selectedLensTypeId = payload;
      state.selectedLensIndexId = 0;
      state.selectedLensSphId = 0;
      state.selectedLensCylId = 0;
      state.selectedProductId = 0;
      state.lensIndexes = [];
      state.lensSphs = [];
      state.lensCyls = [];
      state.products = [];
      state.loading = false;
    },
    setSTOrderLensIndexes: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.lensIndexes = payload;
      state.selectedLensIndexId = 0;
      state.loading = false;
    },
    setSTOrderSelectedLensIndex: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.selectedLensIndexId = payload;
      state.selectedLensSphId = 0;
      state.selectedLensCylId = 0;
      state.selectedProductId = 0;
      state.lensSphs = [];
      state.lensCyls = [];
      state.products = [];
      state.loading = false;
    },
    setSTOrderLensSphs: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.lensSphs = payload;
      state.selectedLensSphId = 0;
      state.loading = false;
    },
    setSTOrderSelectedLensSph: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.selectedLensSphId = payload;
      state.selectedLensCylId = 0;
      state.selectedProductId = 0;
      state.lensCyls = [];
      state.products = [];
      state.loading = false;
    },
    setSTOrderLensCyls: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.lensCyls = payload;
      state.selectedLensCylId = 0;
      state.loading = false;
    },
    setSTOrderSelectedLensCyl: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.selectedLensCylId = payload;
      state.loading = false;
    },
    setSTOrderProducts: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.products = payload;

      if(state.products !== undefined && state.products !== null && state.products.length === 1){

        state.selectedProductId = payload[0].Value;
        state.selectedProductCode = payload[0].Code;
        state.selectedProductTitle = payload[0].Name;
        state.selectedFee = payload[0].Fee;
        state.selectedQuantity = '1';
      }else{
        state.selectedProductId = 0;
      }

    
      state.loading = false;
    },
    setSTOrderSelectedProduct: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      if(payload === null){
        state.selectedProductId = 0;
        state.selectedProductCode = '';
        state.selectedProductTitle = '';
        state.selectedQuantity = '';
        state.selectedFee = 0;
      }else{
        state.selectedProductId = payload.selectedProductId;
        state.selectedProductCode = payload.selectedProductCode;
        state.selectedProductTitle = payload.selectedProductTitle;
        state.selectedFee = payload.selectedFee;
        state.loading = false;
        state.selectedQuantity = '1';
      }
      
    },
    setSTOrderSelectedQuantity: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.selectedQuantity = payload;
      state.loading = false;
    },
    addOrUpdateItem: (state, { payload }) => {

      console.log("payload: " );
      console.log(payload);

      console.log(state.isRightOn);
      var opticianWarrantyTitle = "";
      if(payload.customerPortalFinalserRole === "Optician" ){
        try {
          opticianWarrantyTitle = payload.authUser.underControlUsers.find(e => e.Value === state.customerPortalUserId).Code ;
        } catch (e) {
          console.log(e); // Logs the error
        }
        
      }
     // {&& state.customerPortalUserId !==  payload.authUser.underControlUsers.find(e => e.Value === state.customerPortalUserId && e.)        )
      
      if(state.isRightOn){
          console.log("isRightOn");
         //یعنی الان لنگه ی راست داره اضافه میشه به آیتم ها 
         //بعدش که اضافه شد باید لنگه ی راست غیر فعال بشه چپ خودش روشن بشه و چپ رو اضافه کنه و لا غیر
          var newRowId = state.items.length + 1;
          //var newItem = { RowId : newRowId , RightProductTitle : payload.selectedProductTitle, RightProductCode : payload.selectedProductCode, RightProductId : payload.selectedProductId , LeftProductTitle : '-', LeftProductCode : '-', LeftProductId : '' , Quantity : 1 , Fee : payload.selectedFee , Consumer : '', Optician : opticianWarrantyTitle, Axis : null , NeedTools : (payload.selectedProductTitle.toLowerCase().startsWith("custom") ? false : (state.cusomerExcludedFromRequiredTools ? false : true) )};
          var newItem = { RowId : newRowId , RightProductTitle : payload.selectedProductTitle, RightProductCode : payload.selectedProductCode, RightProductId : payload.selectedProductId , LeftProductTitle : '-', LeftProductCode : '-', LeftProductId : '' , Quantity : 1 , Fee : payload.selectedFee , Consumer : '', Optician : opticianWarrantyTitle, Axis : null , NeedTools : (state.cusomerExcludedFromRequiredTools ? false : true), NeedCut : '-'};

          newItem.Price =  parseFloat(newItem.Fee) * parseFloat(newItem.Quantity);

          state.items.push(newItem);

          state.selectedRowId = newRowId;
          state.isLeftOn = true;
          state.isRightOn = false;

          
          
      }else if(state.isLeftOn){
        console.log("isLeftOn");
        //یعنی الان لنگه ی چپ معادل راست داره اضافه میشه به آیتم ها 
        //بعدش که اضافه شد هممه چیز به حالت عادی برگرده
        if (state.items.find(e => e.RowId.toString() === state.selectedRowId.toString())) {
          /* ItemExist */
          //if(payload.addQuantityToCurrent ? parseFloat(state.items.find(e => e.RowId.toString() === state.selectedRowId.toString()).Quantity) + parseFloat(payload.selectedQuantity) : parseFloat(payload.selectedQuantity) >= 0){
            state.items.find(e => e.RowId.toString() === state.selectedRowId.toString()).LeftProductCode = payload.selectedProductCode;
            state.items.find(e => e.RowId.toString() === state.selectedRowId.toString()).LeftProductTitle = payload.selectedProductTitle;
            state.items.find(e => e.RowId.toString() === state.selectedRowId.toString()).LeftProductId = payload.selectedProductId;

            state.items.find(e => e.RowId.toString() === state.selectedRowId.toString()).Quantity = 2;
            state.items.find(e => e.RowId.toString() === state.selectedRowId.toString()).Price = parseFloat(state.items.find(e => e.RowId.toString() === state.selectedRowId.toString()).Fee) * parseFloat(state.items.find(e => e.RowId.toString() === state.selectedRowId.toString()).Quantity);  
          //}
        }

        state.selectedRowId = 0;
        state.isLeftOn = false;
        state.isRightOn = false;
        
        //به خاطر عدس دو لنگه این مورد رو همه جا غیر از یک جا صفر کردم
        state.selectedLensBrandId = 0;
        state.selectedLensTypeId = 0;
        state.selectedLensIndexId = 0;
        state.lensTypes = [];
        state.lensIndexes = [];
        state.lensSphs = [];
        
      }else if(state.isOUOn){
        console.log("isOUOn");

        var newRowId = state.items.length + 1;
        //var newItem = { RowId : newRowId , RightProductTitle : payload.selectedProductTitle, RightProductCode : payload.selectedProductCode, RightProductId : payload.selectedProductId , LeftProductTitle : payload.selectedProductTitle, LeftProductCode : payload.selectedProductCode, LeftProductId : payload.selectedProductId , Quantity : 2, Fee : payload.selectedFee , Consumer : '', Optician : opticianWarrantyTitle, Axis : null , NeedTools : (payload.selectedProductTitle.toLowerCase().startsWith("custom") ? false : (state.cusomerExcludedFromRequiredTools ? false : true) )};
        var newItem = { RowId : newRowId , RightProductTitle : payload.selectedProductTitle, RightProductCode : payload.selectedProductCode, RightProductId : payload.selectedProductId , LeftProductTitle : payload.selectedProductTitle, LeftProductCode : payload.selectedProductCode, LeftProductId : payload.selectedProductId , Quantity : 2, Fee : payload.selectedFee , Consumer : '', Optician : opticianWarrantyTitle, Axis : null , NeedTools : (state.cusomerExcludedFromRequiredTools ? false : true), NeedCut : ''};

        newItem.Price =  parseFloat(newItem.Fee) * parseFloat(newItem.Quantity);

        state.items.push(newItem);

        state.selectedRowId = 0;
        state.isLeftOn = false;
        state.isRightOn = false;
        state.isOUOn = false;
        //به خاطر عدس دو لنگه این مورد رو همه جا غیر از یک جا صفر کردم
        state.selectedLensBrandId = 0;
        state.selectedLensTypeId = 0;
        state.selectedLensIndexId = 0;
        state.lensTypes = [];
        state.lensIndexes = [];
        state.lensSphs = [];
          
      }else if(payload.isFromBarcode){

        console.log("isFromBarcode");
          //یعنی از بارکد داره میاد
        console.log(payload);
        if (state.items.find(e => e.RightProductId.toString() === payload.selectedProductId.toString() && e.LeftProductCode === "-")) {
          console.log("found");
      
          if(payload.addQuantityToCurrent ? parseFloat(state.items.find(e => e.RightProductId === payload.selectedProductId).Quantity) + parseFloat(payload.selectedQuantity) : parseFloat(payload.selectedQuantity) >= 0){
            state.items.find(e => e.RightProductId === payload.selectedProductId).Quantity = payload.addQuantityToCurrent ? parseFloat(state.items.find(e => e.RightProductId === payload.selectedProductId).Quantity) + parseFloat(payload.selectedQuantity) : parseFloat(payload.selectedQuantity) ;
            state.items.find(e => e.RightProductId === payload.selectedProductId).Price = parseFloat(state.items.find(e => e.RightProductId === payload.selectedProductId).Fee) * parseFloat(state.items.find(e => e.RightProductId === payload.selectedProductId).Quantity);  
          }
        
        }else{
        
          console.log("not found");
          if(payload.selectedQuantity >= 0){
  
            //var newItem = { RowId : state.items.length + 1 , RightProductTitle : payload.selectedProductTitle, RightProductCode : payload.selectedProductCode, RightProductId : payload.selectedProductId , LeftProductTitle : '-', LeftProductCode : '-', LeftProductId : null, Quantity : payload.selectedQuantity , Fee : payload.selectedFee , Consumer : '', Optician : '', Axis : '', NeedTools : (payload.selectedProductTitle.toLowerCase().startsWith("custom") ? false : (state.cusomerExcludedFromRequiredTools ? false : true) ) };
            var newItem = { RowId : state.items.length + 1 , RightProductTitle : payload.selectedProductTitle, RightProductCode : payload.selectedProductCode, RightProductId : payload.selectedProductId , LeftProductTitle : '-', LeftProductCode : '-', LeftProductId : null, Quantity : payload.selectedQuantity , Fee : payload.selectedFee , Consumer : '', Optician : '', Axis : '', NeedTools : (state.cusomerExcludedFromRequiredTools ? false : true) , NeedCut : '-' };

            newItem.Price =  parseFloat(newItem.Fee) * parseFloat(newItem.Quantity);
  
            state.items.push(newItem);

          }

        }
        //به خاطر عدس دو لنگه این مورد رو همه جا غیر از یک جا صفر کردم
        state.selectedLensBrandId = 0;
        state.selectedLensTypeId = 0;
        state.selectedLensIndexId = 0;
        state.lensTypes = [];
        state.lensIndexes = [];
        state.lensSphs = [];
      }else{
        
           console.log(" ثبت عادی");
           console.log(payload.selectedRowId);
          //وقتی ثبت عادی رخ داده
          if(payload.selectedRowId > 0){
            //ویرایش
            console.log(" ویرایش");
            if (state.items.find(e => e.RowId.toString() === payload.selectedRowId.toString())) {
              /* ItemExist */
              console.log(" ItemExist");
             
                if(payload.addQuantityToCurrent ? parseFloat(state.items.find(e => e.RowId.toString() === payload.selectedRowId.toString()).Quantity) + parseFloat(payload.selectedQuantity) : parseFloat(payload.selectedQuantity) >= 0){
                  state.items.find(e => e.RowId.toString() === payload.selectedRowId.toString()).Quantity = payload.addQuantityToCurrent ? parseFloat(state.items.find(e => e.RowId.toString() === payload.selectedRowId.toString()).Quantity) + parseFloat(payload.selectedQuantity) : parseFloat(payload.selectedQuantity) ;
                  state.items.find(e => e.RowId.toString() === payload.selectedRowId.toString()).Price = parseFloat(state.items.find(e => e.RowId.toString() === payload.selectedRowId.toString()).Fee) * parseFloat(state.items.find(e => e.RowId.toString() === payload.selectedRowId.toString()).Quantity);  
                }       
            }

          }else{
            //جدید
            console.log(" جدید");
            if(payload.selectedQuantity >= 0){
              console.log(" selectedQuantity");
              //var newItem = { RowId : state.items.length + 1 , RightProductTitle : payload.selectedProductTitle, RightProductCode : payload.selectedProductCode, RightProductId : payload.selectedProductId , LeftProductTitle : '-', LeftProductCode : '-', LeftProductId : null,  Quantity : payload.selectedQuantity , Fee : payload.selectedFee, Consumer : '', Optician : '', Axis : '', NeedTools : (payload.selectedProductTitle.toLowerCase().startsWith("custom") ? false : (state.cusomerExcludedFromRequiredTools ? false : true) )  };
              var newItem = { RowId : state.items.length + 1 , RightProductTitle : payload.selectedProductTitle, RightProductCode : payload.selectedProductCode, RightProductId : payload.selectedProductId , LeftProductTitle : '-', LeftProductCode : '-', LeftProductId : null,  Quantity : payload.selectedQuantity , Fee : payload.selectedFee, Consumer : '', Optician : '', Axis : '', NeedTools : (state.cusomerExcludedFromRequiredTools ? false : true) , NeedCut : '-' };

              newItem.Price =  parseFloat(newItem.Fee) * parseFloat(newItem.Quantity);
    
              state.items.push(newItem);

            }

        }

        //به خاطر عدس دو لنگه این مورد رو همه جا غیر از یک جا صفر کردم
        state.selectedLensBrandId = 0;
        state.selectedLensTypeId = 0;
        state.selectedLensIndexId = 0;
        state.lensTypes = [];
        state.lensIndexes = [];
        state.lensSphs = [];
        
      }

    
      //state.selectedLensTypeId = 0;
      //state.lensIndexes = [];
      //state.selectedLensIndexId = 0;
      //state.lensSphs = [];
      state.selectedLensSphId = 0;
      state.lensCyls = [];
      state.selectedLensCylId = 0;
      state.products = [];
      state.selectedProductId = 0;
      state.selectedProductCode = '';
      state.selectedProductTitle = '';
      state.selectedQuantity = '';
      state.selectedFee = 0;

    },
    updateOpticianData : (state , { payload}) =>{

      if (state.items.find(e => e.RowId.toString() === payload.selectedRowId.toString())) {
        /* ItemExist */
        console.log(" ItemExist");
        state.items.find(e => e.RowId.toString() === payload.selectedRowId.toString()).Optician = payload.Value ;
             
      }

    },
    updateNeedToolsData : (state , { payload}) =>{

      if (state.items.find(e => e.RowId.toString() === payload.selectedRowId.toString())) {
        /* ItemExist */
        console.log(" ItemExist");
        console.log(payload);
        state.items.find(e => e.RowId.toString() === payload.selectedRowId.toString()).NeedTools = payload.Value ;
             
      }

    },
    updateAxisData : (state , { payload}) =>{

      if (state.items.find(e => e.RowId.toString() === payload.selectedRowId.toString())) {
        /* ItemExist */
        console.log(" ItemExist");
        state.items.find(e => e.RowId.toString() === payload.selectedRowId.toString()).Axis = payload.Value ;
             
      }

    },
    updateConsumerData : (state , { payload}) =>{

      if (state.items.find(e => e.RowId.toString() === payload.selectedRowId.toString())) {
        /* ItemExist */
        console.log(" ItemExist");
        state.items.find(e => e.RowId.toString() === payload.selectedRowId.toString()).Consumer = payload.Value;
             
      }

    },
    updateNeedCutData : (state , { payload}) =>{

      if (state.items.find(e => e.RowId.toString() === payload.selectedRowId.toString())) {
        /* ItemExist */
        console.log(" ItemExist");
        state.items.find(e => e.RowId.toString() === payload.selectedRowId.toString()).NeedCut = payload.Value;
             
      }

    },
    deleteItem : (state, { payload }) => {
      //state.isRightOn = payload ? true : false;

      if (state.items.find(e => e.RowId.toString() === payload.selectedRowId.toString())) {
        /* ItemExist */
        console.log(" ItemExist");
        state.items = state.items.filter(e => e.RowId.toString() !== payload.selectedRowId.toString());
        console.log(state.items);
        for(var i = 0 ; i < state.items.length ; i++){
          state.items[i].RowId = i + 1;
        }
        
      }
      state.isWaitingForLeft = false;
      state.isLeftOn = false;
      state.isRightOn = false;
      state.isOUOn = false;
      


      state.selectedRowId = 0;

        //به خاطر عدس دو لنگه این مورد رو همه جا غیر از یک جا صفر کردم
      state.selectedLensBrandId = 0;
      state.selectedLensTypeId = 0;
      state.selectedLensIndexId = 0;
      state.lensTypes = [];
      state.lensIndexes = [];
      state.lensSphs = [];
    },
    deleteAllItems : (state, { payload }) => {
      //state.isRightOn = payload ? true : false;

      state.items = [];
      state.isWaitingForLeft = false;
      state.isLeftOn = false;
      state.isRightOn = false;
      state.isOUOn = false;
      


      state.selectedRowId = 0;

        //به خاطر عدس دو لنگه این مورد رو همه جا غیر از یک جا صفر کردم
      state.selectedLensBrandId = 0;
      state.selectedLensTypeId = 0;
      state.selectedLensIndexId = 0;
      state.lensTypes = [];
      state.lensIndexes = [];
      state.lensSphs = [];
    },
    setSTPreviewItemsFilter: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.previewItemsBackup = payload;
    },
    setSTPreviewItems: (state, { payload }) => {
      console.log("payload: " );
      console.log(payload);
      state.previewItems = payload;
      state.previewItemsBackup = payload;
      state.previewItemsDialog = true;
    },
    setSTPreviewItemsDialogClose: (state, { payload }) => {
      state.previewItems = [];
      state.previewItemsBackup = [];
      state.previewItemsDialog = false;
    },
    setRightValue : (state, { payload }) => {
      state.isRightOn = payload ? true : false;
    },
    setLeftValue : (state, { payload }) => {
      state.isLeftOn = payload ? true : false;
    },
    setOUValue : (state, { payload }) => {
      state.isOUOn = payload ? true : false;
    },
    setSTOrderPayType : (state, { payload }) => {
      state.payTypeId = payload;
    },
    setSTOrderDescription: (state, { payload }) => {
      state.description = payload;
    },
    setSTOrderDateMustDelivered: (state, { payload }) => {
      state.dateMustDelivered = payload;
    },
    clearSTOrderItems: (state) => {
      state.items = [];
      state.currentPageIndex = 0;
      state.selectedSTOrder = {};
      state.selectedSTOrderId = null;
    },
    clearSelectedSTOrder: (state) => {
      state.selectedSTOrder = {};
      state.selectedSTOrderId = null;
    },
    clearSTOrderFilters: (state) => {
      state.searchKey = '';
    },

    clearSTOrderData: (state) => {
      state.number = "";
      state.trackingCode = "";
      state.loading = false;
      state.boxMessage = '';
      state.boxType = 0;//1 Error , 2 Success, 3 Info
      state.currentPageIndex = 0;
      state.customerPortalUserId = '';
      state.customerPortalCreatorId = '';
      state.items = [];
      state.selectedSTOrder = {};
      state.selectedSTOrderId = null;
      state.hasMore = true;
      state.searchKey  = '';
      state.fetchPermission = true;
      state.selectedLensBrandId = 0;
      state.lensTypes = [];
      state.selectedLensTypeId = 0;
      state.lensIndexes = [];
      state.selectedLensIndexId = 0;
      state.lensSphs = [];
      state.selectedLensSphId = 0;
      state.lensCyls = [];
      state.selectedLensCylId = 0;
      state.products = [];
      state.selectedProductId = 0;
      state.selectedProductCode = '';
      state.selectedProductTitle = '';
      state.selectedQuantity = '';
      state.selectedFee = 0;
      state.isWaitingForLeft = false;
      state.isLeftOn = false;
      state.isRightOn = false;
      state.isOUOn = false;
      state.previewItems = [];
      state.previewItemsBackup = [];
      state.previewItemsDialog = false;
      state.description = '';
      state.dateMustDelivered = '';
      state.OrderHistory = [];
      state.orderState = '';
      state.payTypeId = 1;
      state.netPrice = 0;
      state.cusomerExcludedFromRequiredTools = false;
    }
  },
});

// export the actions
export const { 
  setSTOrderLoading, setSTOrderLoadingFalse, setSTOrderResultBox, resetSTOrderResultBox, clearSTOrderData, setSTOrderSearchKey, clearSTOrderItems ,clearSTOrderFilters, setSelectedSTOrder , setSelectedSTOrderId, clearSelectedSTOrder, 
  setSTOrderLensBrands, setSTOrderSelectedLensBrand,
  setSTOrderLensTypes, setSTOrderSelectedLensType,
  setSTOrderLensIndexes, setSTOrderSelectedLensIndex,
  setSTOrderLensCyls, setSTOrderSelectedLensCyl,
  setSTOrderLensSphs, setSTOrderSelectedLensSph, setSTOrderCusomerExcludedFromRequiredTools,
  setSTOrderProducts, setSTOrderSelectedProduct,setSTOrderDescription, setSTOrderDateMustDelivered,
  addOrUpdateItem , deleteItem, deleteAllItems, updateOpticianData,updateNeedToolsData, updateAxisData, updateConsumerData, updateNeedCutData,
  setSTOrderSelectedQuantity,
  setRightValue, setLeftValue,setOUValue,
  setSTOrderMatrix , setSTPreviewItems, setSTPreviewItemsDialogClose, setSTPreviewItemsFilter,
  loadSTOrder,
  setCustomerPortalUserId,  clearCustomerPortalUserId,
  setSTOrderReadonly, setSTOrderWrite, setSTOrderPayType, setPostRefId

} = stOrderSlice.actions;

// export the selector (".items" being same as in slices/index.js's "items: something")
export const stOrderItemsSelector = (state) => state.items;

// export the default reducer
export default stOrderSlice.reducer;



// fetch cusomerExcludedFromRequiredTools
export function fetchCusomerExcludedFromRequiredTools(input) {
  return async (dispatch) => {

      dispatch(setSTOrderLoading());
      await axios.post(getCusomerExcludedFromRequiredToolsURL()+'?username='+input.authUser.username + '&password='+encodeURIComponent(input.authUser.password)+'&token='+input.authUser.token)
      .then(response => {
          console.log(response.data);
          dispatch(setSTOrderCusomerExcludedFromRequiredTools(response.data));
      }).catch(function (err) {
        dispatch(setSTOrderResultBox({message : err.message , type : 1}));
      }).finally(()=> {
        dispatch(setSTOrderLoadingFalse());
      });
  }
};

// fetch Brands
export function fetchLensBrands(input) {
  return async (dispatch) => {

      dispatch(setSTOrderLoading());
      await axios.post(getLensBrandsURL()+'?username='+input.authUser.username + '&password='+encodeURIComponent(input.authUser.password)+'&token='+input.authUser.token)
      .then(response => {
          console.log(response.data);
          dispatch(setSTOrderLensBrands(response.data));
      }).catch(function (err) {
        dispatch(setSTOrderResultBox({message : err.message , type : 1}));
      }).finally(()=> {
        dispatch(setSTOrderLoadingFalse());
      });
  }
};
// fetch LensTypes
export function fetchLensTypes(input) {
  return async (dispatch) => {

      dispatch(setSTOrderLoading());
      await axios.post(getSTLensTypesURL()+'?brandId='+input.selectedLensBrandId+'&username='+input.authUser.username + '&password='+encodeURIComponent(input.authUser.password)+'&token='+input.authUser.token)
      .then(response => {

          console.log(response.data);
          dispatch(setSTOrderLensTypes(response.data));

      }).catch(function (err) {
        dispatch(setSTOrderResultBox({message : err.message , type : 1}));
      }).finally(()=> {
        dispatch(setSTOrderLoadingFalse());
      });
  }
};
// fetch Lens Indexes
export function fetchLensIndexes(input) {
  return async (dispatch) => {

      dispatch(setSTOrderLoading());
      await axios.post(getSTLensIndexURL()+'?brandId='+input.selectedLensBrandId+'&lensTypeId='+input.selectedLensTypeId+'&username='+input.authUser.username + '&password='+encodeURIComponent(input.authUser.password)+'&token='+input.authUser.token)
      .then(response => {

          console.log(response.data);
          dispatch(setSTOrderLensIndexes(response.data));
      }).catch(function (err) {
        dispatch(setSTOrderResultBox({message : err.message , type : 1}));
      }).finally(()=> {
        dispatch(setSTOrderLoadingFalse());
      });
  }
};
// fetch Lens Sph
export function fetchLensSphs(input) {
  return async (dispatch) => {

      dispatch(setSTOrderLoading());
      await axios.post(getSTLensSphURL()+'?brandId='+input.selectedLensBrandId+'&lensTypeId='+input.selectedLensTypeId+'&lensIndexId='+input.selectedLensIndexId+'&username='+input.authUser.username + '&password='+encodeURIComponent(input.authUser.password)+'&token='+input.authUser.token)
      .then(response => {

          console.log(response.data);
          dispatch(setSTOrderLensSphs(response.data));

      }).catch(function (err) {
        dispatch(setSTOrderResultBox({message : err.message , type : 1}));
      }).finally(()=> {
        dispatch(setSTOrderLoadingFalse());
      });
  }
};
// fetch Lens Cyl
export function fetchLensCyls(input) {
  return async (dispatch) => {

      dispatch(setSTOrderLoading());
      await axios.post(getSTLensCylURL()+'?brandId='+input.selectedLensBrandId+'&lensTypeId='+input.selectedLensTypeId+'&lensIndexId='+input.selectedLensIndexId+'&sphid='+input.selectedLensSphid+'&username='+input.authUser.username + '&password='+encodeURIComponent(input.authUser.password)+'&token='+input.authUser.token)
      .then(response => {

          console.log(response.data);
          dispatch(setSTOrderLensCyls(response.data));
      }).catch(function (err) {
        dispatch(setSTOrderResultBox({message : err.message , type : 1}));
      }).finally(()=> {
        dispatch(setSTOrderLoadingFalse());
      });
  }
};
// fetch Products
export function fetchProducts(input) {
  return async (dispatch) => {

      dispatch(setSTOrderLoading());
      await axios.post(getSTProductsURL()+'?brandId='+input.selectedLensBrandId+'&lensTypeId='+input.selectedLensTypeId+'&lensIndexId='+input.selectedLensIndexId+'&sphid='+input.selectedLensSphid+'&cylId='+input.selectedCylId+'&username='+input.authUser.username + '&password='+encodeURIComponent(input.authUser.password)+'&token='+input.authUser.token)
      .then(response => {

          console.log(response.data);
          dispatch(setSTOrderProducts(response.data));
      }).catch(function (err) {
        dispatch(setSTOrderResultBox({message : err.message , type : 1}));
      }).finally(()=> {
        dispatch(setSTOrderLoadingFalse());
      });
  }
};

// fetch Product
export function fetchProduct(input) {
  return async (dispatch) => {

      dispatch(setSTOrderLoading());
      await axios.post(getProductByCodeURL()+'?code='+input.code+'&username='+input.authUser.username + '&password='+encodeURIComponent(input.authUser.password)+'&token='+input.authUser.token)
      .then(response => {

          console.log(response.data);
          if(response.data.Value !== null){
            dispatch(addOrUpdateItem({selectedRowId : 0 , selectedProductId : response.data.Value , selectedProductCode : response.data.Code, selectedProductTitle : response.data.Name , selectedQuantity : 1 , selectedFee : response.data.Fee , Consumer : response.data.Consumer, Optician : response.data.Optician, Axis : response.data.Axis, NeedTools : response.data.NeedTools, NeedCut : response.data.NeedCut, addQuantityToCurrent : true , isFromBarcode : input.isFromBarcode , authUser : input.authUser}));
          }else{
            dispatch(setSTOrderResultBox({message : "خطا در بارگذاری محصول" , type : 1}));
          }
          //
          
          
 
      }).catch(function (err) {
        dispatch(setSTOrderResultBox({message : err.message , type : 1}));
      }).finally(()=> {
        dispatch(setSTOrderLoadingFalse());
      });
  }
};

// fetch Product
export function fetchMatrixQuantity(input) {
  return async (dispatch) => {

      dispatch(setSTOrderLoading());
      await axios.post(getMatrixQuantityURL()+'?brandId='+input.brandId+'&lensTypeId='+input.lensTypeId+'&lensIndexId='+input.lensIndexId+'&stockId='+input.stockId+'&username='+input.authUser.username + '&password='+encodeURIComponent(input.authUser.password)+'&token='+input.authUser.token)
      .then(response => {

          console.log(response.data);
          if(response.data.Value !== null){
            
            dispatch(setSTOrderMatrix(response.data));
            //dispatch(addOrUpdateItem({selectedRowId : 0 , selectedProductId : response.data.Value , selectedProductCode : response.data.Code, selectedProductTitle : response.data.Name , selectedQuantity : 1 , selectedFee : response.data.Fee , addQuantityToCurrent : true , isFromBarcode : input.isFromBarcode , authUser : input.authUser}));
          }else{
            dispatch(setSTOrderResultBox({message : "خطا در بارگذاری ماتریس موجودی" , type : 1}));
          }
          //
          
 
      }).catch(function (err) {
        dispatch(setSTOrderResultBox({message : err.message , type : 1}));
      }).finally(()=> {
        dispatch(setSTOrderLoadingFalse());
      });
  }
};

export function getSTOrderPreview(input) {
  return async (dispatch) => {
    
    //console.log("The Input");
    //console.log(input);
    dispatch(setSTOrderLoading());
    let orderItems = [];
    
    var rowId = 1;
    for(var i = 0 ;  i < input.stOrder.items.length ; i++){

        console.log("start");
        var item = input.stOrder.items[i];
        console.log(item);
        if(item.LeftProductId > 0){
          console.log("LeftProductId ");
          var leftRowId = rowId + 1;
          //یعنی چپ و راست
            orderItems.push(
            {
              RowNumber : rowId,
              ProductId : parseInt(item.RightProductId),
              Quantity : 1,
              NeedTools : item.NeedTools,
              CorrespondingLeftRowNmber : leftRowId,
              Consumer : item.Consumer,
              Optician: item.Optician,
              Axis : item.Axis,
              NeedCut : item.NeedCut
            });
            orderItems.push(
            {
              RowNumber : leftRowId,
              ProductId : parseInt(item.LeftProductId),
              Quantity : 1,
              NeedTools : item.NeedTools,
              CorrespondingLeftRowNmber : null,
              Consumer : '',
              Optician: '',
              Axis : null,
              NeedCut : '-'
            });
            rowId++;
            console.log(orderItems);
        }else{
          //یعنی تک لنگه
          orderItems.push(
            {
              RowNumber : rowId,
              ProductId : parseInt(item.RightProductId),
              Quantity : parseInt(item.Quantity),
              NeedTools : item.NeedTools,
              CorrespondingLeftRowNmber : null,
              Consumer : '',
              Optician: '',
              Axis : null,
              NeedCut : '-'
            });
        }

        rowId++;
    }

    var _dateMustDelivered = "";
   
    if(input.stOrder.dateMustDelivered === ""){
      var theDate = new Date();
      //var day = zeroPad(theDate.getDate() , 2);
      //var month = zeroPad(theDate.getMonth() , 2);
      //var year = theDate.getFullYear();
      _dateMustDelivered = theDate.toISOString();//moment.from(year + "/" + month + "/"+ day, 'fa', 'YYYY/MM/DD')._i.toString().slice(0,10);
  }else{

    _dateMustDelivered = moment.from(input.stOrder.dateMustDelivered, 'fa', 'YYYY/MM/DD')._i.toString().slice(0,10);
  }    

 
   
    let order = {};
    order = {
      OrderId: input.stOrder.selectedSTOrderId,
      Customer : 0,
      Consumer : '-',
      DateMustDelivered : _dateMustDelivered,//new Date().toISOString(),//'2012-04-23T18:25:43.511Z',//'2012-04-23T18:25:43.511Z',//      today,
      iOldLens : '',
      StoreName : '-',
      Description : input.stOrder.description,
      OrderItems: orderItems,
      CustomerPortalUserId : input.stOrder.customerPortalUserId,
      CustomerPortalCreatorId : input.authUser.id,
      PayTypeID : input.stOrder.payTypeId
    }

    var data = JSON.stringify(order);

    console.log("data before send");
    console.log(data);

    var config = {
      method: 'post',
      url: `${getSTOrderPreviewURL()}?username=${input.authUser.username}&password=${encodeURIComponent(input.authUser.password)}&token=${input.authUser.token}`,
      headers: { 
        'Content-Type': 'application/json'
      },
      data : data
    };

    console.log(data);
    await axios(config).then(function (response) {
       
        //console.log("response.data");
        console.log(response.data);
        if(response.data.STOrderItemPreviewDataModels.length > 0 ){
          dispatch(setSTPreviewItems(response.data.STOrderItemPreviewDataModels));
        }else{
          dispatch(setSTOrderResultBox({message : "خطا در بارگذاری اقلام پیش نمایش" , type : 1}));
        }

      }).catch(function (err) {
        dispatch(setSTOrderResultBox({message : err.message , type : 1}));

      }).finally(()=> {
        dispatch(setSTOrderLoadingFalse());
      });
  
  };
}


export function submitSTOrder(input) {
  return async (dispatch) => {
    
    //console.log("The Input");
    //console.log(input);
    dispatch(setSTOrderLoading());
    let orderItems = [];
    
    var rowId = 1;
    for(var i = 0 ;  i < input.stOrder.items.length ; i++){

        var item = input.stOrder.items[i];
        if(item.LeftProductId > 0){

          var leftRowId = rowId + 1;
          //یعنی چپ و راست
            orderItems.push(
            {
              RowNumber : rowId,
              ProductId : parseInt(item.RightProductId),
              Quantity : 1,
              NeedTools : item.NeedTools,
              CorrespondingLeftRowNmber : leftRowId,
              Consumer : item.Consumer,
              Optician: item.Optician,
              Axis : item.Axis,
              NeedCut : item.NeedCut
            });
            orderItems.push(
            {
              RowNumber : leftRowId,
              ProductId : parseInt(item.LeftProductId),
              Quantity : 1,
              NeedTools : item.NeedTools,
              CorrespondingLeftRowNmber : null,
              Consumer : '',
              Optician: '',
              Axis : null,
              NeedCut : '-'
            });
            rowId++;
        }else{
          //یعنی تک لنگه
          orderItems.push(
            {
              RowNumber : rowId,
              ProductId : parseInt(item.RightProductId),
              Quantity : parseInt(item.Quantity),
              NeedTools : item.NeedTools,
              CorrespondingLeftRowNmber : null,
              Consumer : '',
              Optician: '',
              Axis : null,
              NeedCut : '-'
            });
        }

        rowId++;
    }

    var _dateMustDelivered = "";
    if(input.stOrder.dateMustDelivered === ""){
      var theDate = new Date();
    
      _dateMustDelivered = theDate.toISOString();//moment.from(year + "/" + month + "/"+ day, 'fa', 'YYYY/MM/DD')._i.toString().slice(0,10);
  }else{
    _dateMustDelivered = moment.from(input.stOrder.dateMustDelivered, 'fa', 'YYYY/MM/DD')._i.toString().slice(0,10);
  }    
 

    let order = {};
    order = {
      OrderId: input.stOrder.selectedSTOrderId,
      Customer : 0,
      Consumer : '-',
      DateMustDelivered : _dateMustDelivered,//new Date().toISOString(),//'2012-04-23T18:25:43.511Z',//'2012-04-23T18:25:43.511Z',//      today,
      iOldLens : '',
      StoreName : '-',
      Description : input.stOrder.description,
      OrderItems: orderItems,
      CustomerPortalUserId : input.stOrder.customerPortalUserId,
      CustomerPortalCreatorId : input.authUser.id,
      PayTypeID : input.stOrder.payTypeId

    }

    var data = JSON.stringify(order);

    //console.log("data");
    //console.log(data);

    var config = {
      method: 'post',
      url: `${getSubmitSTOrderURL()}?username=${input.authUser.username}&password=${encodeURIComponent(input.authUser.password)}&token=${input.authUser.token}`,
      headers: { 
        'Content-Type': 'application/json'
      },
      data : data
    };

    //console.log(data);
    await axios(config).then(function (response) {
       
        console.log("response.data");
        console.log(response.data);
        if(response.data.ID > 0 ){
          console.log("Success");
          if(input.stOrder.payTypeId === 2 && response.data.Value !== undefined && response.data.Value !== null && response.data.Value.length > 0){
              //Go to Online Payment
              dispatch(clearSTOrderData());


              localStorage.removeItem('oldPosRefId');
              localStorage.removeItem('oldOrderId');
              localStorage.removeItem('amount');
          
              dispatch(setSTOrderLoading());
          
              //dispatch(setStatisticsLoading());
          
             axios.post(getOrderPaymentURL()+'?type=1&orderId='+ response.data.ID + '&amount='+parseFloat(response.data.Value)+'&username='+input.authUser.username + '&password='+encodeURIComponent(input.authUser.password)+'&token='+input.authUser.token)
                .then(response => {
                    dispatch(setPostRefId(response.data));
                   
                    localStorage.setItem('oldPosRefId', response.data);
                    localStorage.setItem('oldOrderId', response.data.ID);
                    localStorage.setItem('amount', parseFloat(response.data.Value));
          
                    postRefId(response.data);
          
                }).catch(function (err) {
                  console.log(err);
                  dispatch(setSTOrderResultBox({message : err.message , type : 1}));
                  //console.log(errors[err.response.data]);
                  
                  //dispatch(setPaymentError(err.message + '  ' + err.response.data + ' ' + errors[err.response.data]));

                }).finally(()=> {
          
                });


          }else{
            dispatch(clearSTOrderData());
            dispatch(setSTOrderResultBox({message : response.data.Message , type : 2}));
          }
         
        }else{
          dispatch(setSTOrderResultBox({message : response.data.Message , type : 1}));
        }

      }).catch(function (err) {
        dispatch(setSTOrderResultBox({message : err.message , type : 1}));

      }).finally(()=> {
        dispatch(setSTOrderLoadingFalse());
      });
  
  };
}


// fetch rxOrder
export function fetchSTOrder(input ) {
  return async (dispatch) => {

     dispatch(setSTOrderLoading());
      await axios.post(getOrderURL()+'?orderId='+input.orderId+'&type=1&isDetails='+input.isDetails+'&username='+input.authUser.username + '&password='+encodeURIComponent(input.authUser.password)+'&token='+input.authUser.token)
      .then(response => {
          console.log(response.data);
          if(response.data.OrderId > 0 ){
            console.log("Load Order");
            dispatch(loadSTOrder(response.data));

            if(input.isDetails === 1){
              dispatch(setSTOrderReadonly());
            }

            if(response.data.STOrderItemPreviewDataModels.length > 0 ){
              dispatch(setSTPreviewItems(response.data.STOrderItemPreviewDataModels));
              dispatch(setOrderLoadingFalse());
            }else{
              dispatch(setSTOrderResultBox({message : "خطا در بارگذاری اقلام پیش نمایش" , type : 1}));
            }

          }else{
            dispatch(setSTOrderResultBox({message : "خطا در بارگذاری سفارش" , type : 1}));
          }
          
      }).catch(function (err) {
        dispatch(setSTOrderResultBox({message : err.message , type : 1}));
      }).finally(()=> {
        dispatch(setSTOrderLoadingFalse());
        dispatch(setOrderLoadingFalse());
      });
  }
};



// Change RXOrder State
export function ChangeSTOrderState(input) {
  return async (dispatch) => {
    
    //console.log("The Input");
    //console.log(input);
    dispatch(setSTOrderLoading());
  
   
  let OrdersToApprove = {};
  OrdersToApprove = {

    OrderIds : [input.stOrder.selectedSTOrderId],
    DstStates: [input.newState ],//["در_صف_تولید"] ,
    Descrptions : ["-"] // [input.stOrder.selectedRXStateDescription]
  }

    var data = JSON.stringify(OrdersToApprove);
    //console.log(data);
    console.log(data);
    var config = {
      method: 'post',
      url: `${getChangeOrderStateRL()}?username=${input.authUser.username}&password=${encodeURIComponent(input.authUser.password)}&token=${input.authUser.token}`,
      headers: { 
        'Content-Type': 'application/json'
      },
      data : data
    };

    //console.log(data);
    await axios(config).then(function (response) {
       
        //console.log("response.data");
        console.log(response.data);
        if(response.data.ID > 0 ){
          console.log("Success");
          dispatch(clearSTOrderData());
          //dispatch(initialSTOrder());
          dispatch(setSTOrderResultBox({message : response.data.Message , type : 2}));
        }else{
          dispatch(setSTOrderResultBox({message : response.data.Message , type : 1}));
        }

      }).catch(function (err) {
        dispatch(setSTOrderResultBox({message : err.message , type : 1}));

      }).finally(()=> {
        dispatch(setSTOrderLoadingFalse());
      });
  
  };
}


export function submitOrderPayment(input) {
  return async (dispatch) => {
    
    //console.log("The Input");
    //console.log(input);
    dispatch(setSTOrderLoading());
   

        if(input.stOrder.selectedSTOrderId > 0 && input.stOrder.orderState === "در_انتظار_پرداخت"){

              //Go to Online Payment
              dispatch(clearSTOrderData());
              localStorage.removeItem('oldPosRefId');
              localStorage.removeItem('oldOrderId');
              localStorage.removeItem('amount');
          
              dispatch(setSTOrderLoading());
          
              //dispatch(setStatisticsLoading());
          
             axios.post(getOrderPaymentURL()+'?type=1&orderId='+ input.stOrder.selectedSTOrderId + '&amount='+parseFloat(input.stOrder.netPrice)+'&username='+input.authUser.username + '&password='+encodeURIComponent(input.authUser.password)+'&token='+input.authUser.token)
                .then(response => {
                    dispatch(setPostRefId(response.data));
                   
                    localStorage.setItem('oldPosRefId', response.data);
                    localStorage.setItem('oldOrderId', response.data.ID);
                    localStorage.setItem('amount', parseFloat(response.data.Value));
          
                    postRefId(response.data);
          
                }).catch(function (err) {
                  console.log(err);
                  dispatch(setSTOrderResultBox({message : err.message , type : 1}));
                  //console.log(errors[err.response.data]);
                  
                  //dispatch(setPaymentError(err.message + '  ' + err.response.data + ' ' + errors[err.response.data]));

                }).finally(()=> {
          
                });


          }else{
            dispatch(clearSTOrderData());
            dispatch(setSTOrderResultBox({message : "سفارش قابل پرداخت نیست" , type : 2}));
          }
  };
}



export function testThe(input) {
  return async (dispatch) => {
    
  

    var form = document.createElement("form");
    form.setAttribute("method", "POST");
    form.setAttribute("action", getTestRedirectURL());
    form.setAttribute("target", "_self");
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);

    //dispatch(setSTOrderLoading());
  
    {/* 
    await axios.post(getOrderPaymentConfirmationURL()+'?oldOrderID=1161877&orderId=1161877&amount=230000&saleRefId=22&type=1&username='+input.authUser.username + '&password='+encodeURIComponent(input.authUser.password)+'&token='+input.authUser.token)
                .then(response => {
                    
          
                }).catch(function (err) {
                  console.log(err);
                  dispatch(setSTOrderResultBox({message : err.message , type : 1}));
                  //console.log(errors[err.response.data]);
                  
                  //dispatch(setPaymentError(err.message + '  ' + err.response.data + ' ' + errors[err.response.data]));

                }).finally(()=> {
          
                });
*/}


                

  };
}




export const postRefId = (refIdValue) => {
  var form = document.createElement("form");
  form.setAttribute("method", "POST");
  form.setAttribute("action", "https://bpm.shaparak.ir/pgwchannel/startpay.mellat");
  form.setAttribute("target", "_self");
  var hiddenField = document.createElement("input");
  hiddenField.setAttribute("name", "RefId");
  hiddenField.setAttribute("value", refIdValue);
  form.appendChild(hiddenField);
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
}